import { render, staticRenderFns } from "./view-files-modal.vue?vue&type=template&id=62f21aa5"
import script from "./view-files-modal.vue?vue&type=script&lang=js"
export * from "./view-files-modal.vue?vue&type=script&lang=js"
import style0 from "./view-files-modal.vue?vue&type=style&index=0&id=62f21aa5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports